import { Settings } from "../../Settings";

/**
 * @abstract
 */
export default class Sprite {
    /**
     * @param {number} spriteX 
     * @param {number} spriteY 
     */
    constructor(spriteX, spriteY) {
        /**
         * @constant
         * @type {number}
         */
        this.spriteX = spriteX;
        /**
         * @constant
         * @type {number}
         */
        this.spriteY = spriteY;
    }

    /**
     * @abstract
     * @returns {Image}
     */
    getImage() {}

    /**
     * @abstract
     * @returns {number}
     */
    getSize() {
        return Settings.tile.size;
    }
}
